import { userContexts } from '@edulastic/constants'
import API from './utils/API'

const api = new API()
const prefix = '/user-context'

const {
  LAST_ACCESSED_PLAYLIST,
  RECENT_PLAYLISTS,
  USER_CUSTOM_KEYPADS,
  VIEWED_TUTORIALS,
  DASHBOARD_VERSION,
  REPORTS_LANDING_BANNER,
} = userContexts.userContextTypes

const setLastUsedPlayList = ({ _id, title, grades, subjects }) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: LAST_ACCESSED_PLAYLIST,
      value: {
        _id,
        title,
        grades,
        subjects,
      },
    },
  })

const setRecentUsedPlayLists = (playLists) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: RECENT_PLAYLISTS,
      value: [playLists],
    },
  })

const getRecentPlayLists = () =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}?name=${RECENT_PLAYLISTS}`,
    })
    .then((response) => response.data.result)

const getLastPlayList = () =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}?name=${LAST_ACCESSED_PLAYLIST}`,
    })
    .then((response) => response.data.result)

const storeCustomKeypad = (keypad) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: USER_CUSTOM_KEYPADS,
      value: [keypad],
    },
  })

const updateCustomKeypad = (keypad, documentId) =>
  api
    .callApi({
      method: 'put',
      url: `${prefix}/${documentId}`,
      data: {
        filter: {
          _id: keypad._id,
        },
        data: keypad,
      },
    })
    .then((response) => response.data.result)

const getCustomKeypad = () =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}?name=${USER_CUSTOM_KEYPADS}`,
    })
    .then((response) => response.data.result)

const deleteCustomKeypad = (documentId, filter) =>
  api.callApi({
    method: 'delete',
    url: `${prefix}/${documentId}`,
    data: filter,
  })

const getViewedTutorials = () =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}?name=${VIEWED_TUTORIALS}`,
    })
    .then((response) => response.data.result)

const storeViewedTutorials = (viewedTutorials) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: VIEWED_TUTORIALS,
      value: viewedTutorials,
    },
  })

const setDashboardVersion = (dashboardData) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: DASHBOARD_VERSION,
      value: dashboardData,
    },
  })

const getUserContexts = (names) =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}/all`,
      params: { names },
    })
    .then((response) => response.data.result)

const getReportSummaryBannerState = () =>
  api
    .callApi({
      method: 'get',
      url: `${prefix}?name=${REPORTS_LANDING_BANNER}`,
    })
    .then((response) => response.data.result)

const setReportSummaryBannerState = (clickCount) =>
  api.callApi({
    method: 'post',
    url: `${prefix}`,
    data: {
      name: REPORTS_LANDING_BANNER,
      value: { clickCount },
    },
  })

export default {
  setLastUsedPlayList,
  setRecentUsedPlayLists,
  getRecentPlayLists,
  getLastPlayList,
  storeCustomKeypad,
  getCustomKeypad,
  updateCustomKeypad,
  deleteCustomKeypad,
  getViewedTutorials,
  storeViewedTutorials,
  setDashboardVersion,
  getUserContexts,
  getReportSummaryBannerState,
  setReportSummaryBannerState,
}
